import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import * as _ from "lodash";

export class TagsAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  createTagSuccess() {
    const message = {
      body: 'TAG_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createTagError(error?) {
    const message = {
      body: 'TAG_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'message')
    };
    return this.bringozToastService.error(message)
  }

  editTagSuccess() {
    const message = {
      body: 'TAG_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editTagError() {
    const message = {
      body: 'TAG_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteTagSuccess() {
    const message = {
      body: 'TAG_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteTagError() {
    const message = {
      body: 'TAG_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.tags')
  .service('tagsAlertsService', TagsAlertsService);
